; (function ($) {
    var api = require('./xl_api');
    var Global = require('./global');

    /**
     * 统计接口
     * @class Stat
     * @constructor
     */
    var Stat = {
        /** 
         * 用户观影信息采集
         * @method favorCollection
         */
        favorCollection: function (movieid) {
            var userid = api.getUserID();
            var peerid = api.getPeerID();
            var collectInfo = {};
            userid && (collectInfo.userid = userid);
            peerid && (collectInfo.peerid = peerid);
            movieid && (collectInfo.movieid = movieid);

            $.ajax({
                url: 'http://in.xl9.xunlei.com/index.php/movie/click',
                dataType: 'jsonp',
                data: collectInfo,
                success: function (json) { },
                error: function (res, err) { }
            });
        },

        /**
         * 埋点统计
         * @method trackEvent
         */
        trackEvent: function () {
            // console.log('[STAT][trackEvent] ' + JSON.stringify(arguments[0]));
            return api.trackEvent.apply(api, arguments);
        }
    };

    if (typeof exports === 'object') {
        module.exports = Stat;
    }
})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/stat.js
// module id = 4
// module chunks = 1 2 3 5 6 7 8 9 10 11 12